import '/components/estate-sidebar/estate-sidebar.scss';
